import { render } from "./MyTendinous.vue?vue&type=template&id=40fc3d28"
import script from "./MyTendinous.vue?vue&type=script&lang=js"
export * from "./MyTendinous.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__